import { Box, Container, Stack, Text } from "@chakra-ui/react";
import { FaDisplay } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import PublicLayout from "../../components/public/Layout/layout";
const PublicCoursesList = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const courseContent = ["pdf", "video", "exam", "homework"];

  return (
    <PublicLayout color="white" bg="main_1">
      <Container maxW="container.xl" py={36}>
        <Stack
          flexDirection="row"
          gap={4}
          pt={30}
          alignItems="center"
          justifyContent="center"
        >
          {courseContent?.map((val, index) => (
            <Box
              bg="gray.100"
              w="200px"
              h="200px"
              borderRadius="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              color="#4A5568"
              cursor="pointer"
              _hover={{
                color: "main_1",
              }}
              gap={8}
              onClick={() => navigate(`/course/${id}/sections/${val}`)}
            >
              <FaDisplay size={50} />
              <Text fontSize="20px" fontWeight={600} textTransform="capitalize">
                {val}
              </Text>
            </Box>
          ))}
        </Stack>
      </Container>
    </PublicLayout>
  );
};

export default PublicCoursesList;
